import { makeRule } from '@core/utils/rule.js'

export let searchRules = {}

export let formRules = {
  name: [
    {required: true, message: '项目名称不能为空', trigger: 'blur'},
  ],
  number: [
    {required: true, message: '项目编号不能为空', trigger: 'blur'},
  ],
  executive_budget: [
    {required: true, message: '预估执行成本不能为空', trigger: 'blur'},
  ],
  ticket_predict: [
    {...makeRule('请输入正确的开票预估', 'number'), min: 0},
  ],
  gross_rate_predict: [
    {...makeRule('请输入正确的预估毛利率', 'number')},
  ],
  starttime: [
    {required: true, message: '开始时间不能为空', trigger: 'blur'},
  ],
  endtime: [
    {required: true, message: '结束时间不能为空', trigger: 'blur'},
  ],
  enable_release_notice: [
    {required: true, message: '任务发布通知不能为空', trigger: 'change'},
    {...makeRule('任务发布通知不能为空', 'integer'), min: 0},
  ],
  type: [
    {required: true, message: '项目类型不为空', trigger: 'blur'},
  ],
  detail: [
    {required: true, message: '毛利率小于35% 时备注不能为空', trigger: 'blur'},
  ],
  // 选填
  bu_approver: [
    {required: true, message: 'BO审核不能为空', trigger: 'blur'},
    {...makeRule('BO审核不能为空', 'integer'), min: 1},
  ],
  receiver: [
    {required: true, message: '收件人不能为空', trigger: 'blur'},
  ],
  first_approver: [
    {required: true, message: '一级审核不能为空', trigger: 'blur'},
    {...makeRule('一级审核不能为空', 'integer'), min: 1},
  ],
  second_approver: [
    {required: true, message: '二级审核不能为空', trigger: 'blur'},
    {...makeRule('二级审核不能为空', 'integer'), min: 1},
  ],
  finance_approver: [
    {required: true, message: '财务审核不能为空', trigger: 'blur'},
    {...makeRule('财务审核不能为空', 'integer'), min: 1},
  ],
  bd: [
    {required: true, message: 'BD不能为空', trigger: 'blur'},
    {...makeRule('BD不能为空', 'integer'), min: 1},
  ],
  bu: [
    {required: true, message: 'BO不能为空', trigger: 'blur'},
    {...makeRule('BO不能为空', 'integer'), min: 1},
  ],
  // 选填
  annual_cooperation_scale: [
    {...makeRule('请输入年度合作规模', 'number'), min: 0.01},
  ],
  annual_cooperation_times: [
    {...makeRule('全年合作次数', 'integer'), min: 1},
  ],
  project_category: [
    {required: true, message: '项目分类不能为空', trigger: 'blur'},
  ],
  execute_rate: [
    {required: true, message: '执行频次不能为空', trigger: 'blur'},
  ],
  contract_no: [
    {required: true, message: '所属合同编号不能为空', trigger: 'blur'},
  ],
  project_level: [
    {...makeRule('项目等级不为空', 'integer')},
  ],
  review_group: [
    {...makeRule('审核归属不为空', 'integer')},
  ],
  distribute_type: [
    {...makeRule('服务类型不为空', 'integer')},
  ],
  is_first_execute: [
    {...makeRule('项目初次执行不为空', 'integer')},
  ],
  business_process_completed: [
    {...makeRule('商务流程完备不为空', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/customer-project/customer-project.rules.js